import { cssVar } from '@helpers/cssVar';
import { Device, from } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import { ReactComponent as SvgTick } from '@img/icons/tick.svg';
import styled from 'styled-components';
import brand from '@helpers/brand';
const Container = styled.div `
  position: relative;
  display: block;
  width: auto;

  & + & {
    margin-top: 15px;
  }

  @media ${from(Device.Tablet)} {
    & + & {
      margin-top: 0;
      margin-left: 56px;
    }
  }
`;
const Tick = styled(SvgTick) `
  position: absolute;
  left: 3px;
  top: 5px;
  color: ${cssVar('accentColor')};
  width: 18px;
  opacity: 0;
  z-index: 1;
`;
const CheckboxItem = styled.label `
  position: relative;
  display: block;
`;
const CheckboxInput = styled.input `
  ${srOnly}
`;
const CheckboxText = styled.span `
  display: block;
  ${ParagraphStyles.SmallStyles};
  margin: 0;
  padding: 0 0 0 32px;

  .theme-apl & {
    ${ParagraphStyles.RegularStyles};
    @media ${from(Device.DesktopLarge)} {
      font-size: 18px;
      line-height: 28px;
    }
  }

  &::after,
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    border-radius: 5px;
    box-sizing: border-box;
    height: 25px;
    width: 25px;
  }

  &::before {
    border: 1px solid ${cssVar('fgColor')};
    background-color: ${brand.white};
    z-index: 1;
  }

  ${CheckboxInput}:checked + & {
    ${Tick} {
      opacity: 1;
    }
  }
`;
export default {
    Container,
    CheckboxInput,
    CheckboxItem,
    CheckboxText,
    Tick,
};
